import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from "@angular/core";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";
import { SaveService } from '../../../../services/save.service';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Subject } from "rxjs";
import { ContractBundleTranslationAuditPopupComponent } from "./contractbundletranslationauditpopup.component";
import { ContractBundleListService } from "./contractbundlelist.service";
import { ToastrService } from 'ngx-toastr';
import { Utils } from "src/app/utils/utils";
import { HttpClient } from "@angular/common/http"

@Component({
    selector: "contractbundlelist",
    templateUrl: './contractbundlelist.component.html',
    styleUrls: ['./contractbundlelist.component.less', '../../../../style/mat-table.component.less'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*', })),
            transition('expanded => collapsed', [animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
        ]),
    ],
    standalone: false
})

export class ContractBundleListComponent implements OnInit {
    @Input('list') list: ContractBundle[] = [];
    @Output() onReload = new EventEmitter<{}>();

    columnsToDisplay = ['arrow','bundle', 'actions'];
    subcolumnsToDisplay = ['feature', 'localContractLine', 'featureActions'];

    @ViewChild(MatTable, { static: true }) table!: MatTable<any>;

    public dataSource = new MatTableDataSource<ContractBundle>();

    filter: string = '';

    subscriptionLanguage: any;
    subscriptionTenant: any;
    subscriptions: any[] = [];

    expandedElements = new Set();

    protected _onDestroy = new Subject<void>();
    constructor(private readonly defaults: DefaultValuesService, 
        private readonly saveService: SaveService, 
        private readonly dialog: MatDialog, 
        private readonly contractBundleListService: ContractBundleListService, 
        private readonly toastrService: ToastrService,
        @Inject('BASE_URL') private readonly baseUrl: string,
        private readonly http: HttpClient) {}

    ngOnChanges() {
        this.dataSource.data = this.list
        this.saveService.showSaveButton(false)
        this.saveService.addListener(this)
    }

    ngOnInit() {
        this.getHeader();
        this.subscriptionTenant = this.defaults.tenantMessageChanges$.subscribe(() => {
            this.getHeader()
        });
        this.saveService.addListener(this);
    }

    ngOnDestroy() {
        this.saveService.removeListener(this);
        this.subscriptions.forEach(x => x.unsubscribe());
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    getHeader() {
        if (this.defaults.isReadonlyUser) {
            this.columnsToDisplay = ['bundle'];
            this.subcolumnsToDisplay = ['feature', 'localContractLine'];
        } else {
            this.columnsToDisplay = ['arrow', 'bundle', 'actions'];
            this.subcolumnsToDisplay = ['feature', 'localContractLine', 'featureActions'];
        }
    }

    pushPopElement(element: ContractBundle) {
        if (this.expandedElements.has(element.Bundle)) {
            this.expandedElements.delete(element.Bundle);
        }
        else {
            this.expandedElements.add(element.Bundle);             
        }
    }

    checkExpanded(element: ContractBundle) {
        return this.expandedElements.has(element.Bundle);
    }

    deleteBundle(bundleId: number) {
        Utils.httpDeleteContractBundleByTenant(
            this.http
            , this.baseUrl
            , bundleId
            , this
            , function (tthis: ContractBundleListComponent) {
                tthis.onReload.emit({})
            }
        );
    }

    saveTranslation(feature: ContractBundleFeatureDetail) {
        const model: ContractBundleLocalTranslationUpdate = {
            BundleId: feature.BundleId,
            FeatureId: feature.FeatureId,
            LocalContractLine: feature.LocalContractLine
        };

        this.contractBundleListService.updateContractBundleTranslation(model).subscribe({
            next: () => {
                this.toastrService.success('Translation updated successfully');
                this.onReload.emit();
            },
            error: (error) => {
                this.toastrService.error('Error updating translation');
                console.error('Error updating translation:', error);
            }
        });
    }

    openAuditHistory(bundleId: number, bundleName: string) {
        this.dialog.open(ContractBundleTranslationAuditPopupComponent, {
            panelClass: 'custom-mat-dialog',
            disableClose: false,
            data: {
                bundleId: bundleId,
                bundleName: bundleName
            }
        });
    }
}